import { groups } from 'd3-array';
import slugify from 'slugify';
import allPolls from './all-polls.json';
import { parseAll, mediaOutletOverrides } from './parse';
import {
  createTrendLineData,
  createGroupTrendData,
  determineExtents,
} from './summarize';
import { dataConfig } from '$lib/constants/crosswalk';

// TODO: Point this at the real polling data endpoint once it's live, and
// swap `loadLocalData()` below for `fetchData()`. Left commented rather than
// deleted since the URL-fetch shape (and error handling) will look the same
// once there's a real S3 endpoint to hit — just the BASE_URL changes.
//
// const BASE_URL = 'https://graphics.thomsonreuters.com/.../israel-election-polling';
//
// export const fetchData = async () => {
//   const url = `${BASE_URL}/polls.json`;
//   try {
//     const response = await fetch(url);
//     if (!response.ok) {
//       throw new Error(`Response status: ${response.status}`);
//     }
//     return await response.json();
//   } catch (error) {
//     console.error('Error fetching data from URL: ', url);
//     console.error(error.message);
//   }
// };

/** Active data source while the live endpoint doesn't exist yet. */
export const loadLocalData = () => allPolls;

const isExcluded = (record) => {
  const flags = record[dataConfig.auditFlagsField] || [];
  return flags.some((flag) => dataConfig.excludeAuditFlags.includes(flag));
};

const isBeforeStartDate = (record) =>
  record[dataConfig.dateField] < dataConfig.startDate;

const isExcludedMediaOutlet = (record) =>
  dataConfig.excludeMediaOutlets.includes(record[dataConfig.mediaOutletField]);

/**
 * Shapes raw poll records into everything the chart needs: the flat dot
 * data, LOESS trend lines per party, their date extents, and the same three
 * things again broken out per media outlet (for the media outlet filter nav).
 */
export const returnStructuredData = (all) => {
  const scoped = all.filter(
    (d) => !isExcluded(d) && !isBeforeStartDate(d) && !isExcludedMediaOutlet(d)
  );

  const data = parseAll(scoped);
  const trends = createTrendLineData(data);
  const extents = determineExtents(trends);

  const byMediaOutlet = {};
  for (const [rawMediaOutlet, records] of groups(
    scoped,
    (d) => d[dataConfig.mediaOutletField]
  )) {
    const mediaOutletName =
      mediaOutletOverrides[rawMediaOutlet] ?? rawMediaOutlet;
    const slug = slugify(mediaOutletName, { lower: true });
    const mediaOutletData = parseAll(records);
    const { trends: mediaOutletTrends } = createGroupTrendData(mediaOutletData);
    byMediaOutlet[slug] = {
      name: mediaOutletName,
      data: mediaOutletData,
      trends: mediaOutletTrends,
      extents: determineExtents(mediaOutletTrends),
    };
  }

  return { data, trends, extents, byMediaOutlet };
};
